import { render, staticRenderFns } from "./ViewColumn.vue?vue&type=template&id=91fd7be6"
import script from "./ViewColumn.vue?vue&type=script&lang=ts"
export * from "./ViewColumn.vue?vue&type=script&lang=ts"
import style0 from "./ViewColumn.vue?vue&type=style&index=0&id=91fd7be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports